export enum InvoiceType {
  PROFORMA = 122,
  ORIGINAL = 123,
  CREDIT_NOTE = 124,
}
